<div
  class="creator-card"
  [@fade]
  [ngClass]="{ 'selected-creator': selectedCreator.id === creatorItem.id }"
>
  <div class="image_wrapper">
    <stxt-skeleton-loader
      *ngIf="!primaryImageState.isRendered"
      [usage]="EImageUsage.Carousel"
    ></stxt-skeleton-loader>

    <img
      class="primary-image"
      [ngSrc]="creatorItem?.image"
      [ngStyle]="{
        transition: 'opacity 1s ease',
        opacity: primaryImageState.isRendered ? 1 : 0
      }"
      (load)="onPrimaryImageLoad($event)"
      (error)="onPrimaryImageError()"
      priority
      fill
      [alt]="creatorItem.name"
    />

    <img
      class="secondary-image"
      [ngSrc]="
        creatorItem?.secondary_image !== '' ? creatorItem?.secondary_image : creatorItem?.image
      "
      [alt]="creatorItem.secondary_image"
      fill
    />
  </div>
  <div class="creator-card_text">
    <div class="creator-card_name relative">
      <span class="creator-card_name__text">{{ creatorItem.name }}</span>
      <span class="creator-card_name__badge absolute">
        <stxt-svg-icon class="verify-svg" [iconConfig]="verifySvg"></stxt-svg-icon>
      </span>
    </div>
  </div>
</div>
